
export default class TermsDeclarations {

    TextId: number;
    Checked: boolean;

    constructor(TextId: number, Checked: boolean) {
        this.TextId = TextId;
        this.Checked = Checked;
    }

    static NewInstance() {
        return new TermsDeclarations(0, false);
    }
}